import React, {useState} from 'react';
import {Button, Form, Input, Modal} from 'antd';
import Cookies from 'js-cookie';
import {useNavigate} from 'react-router-dom';
import {MdOutlinePassword} from 'react-icons/md';

import Auth from '../../http_request/Model/auth/Auth';
import {toast} from "react-toastify";

const ChangePass = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {
        Cookies.remove('token')
        handleCancel()
        navigate("/login");
    };
    const handleCancel = () => {
        setOpen(false);
    };

    const onFinish = (values) => {
        Auth.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                handleCancel()
                form.resetFields()
                toast.success('تغییرات با موفقیت انجام شد.')
            }, final: () => {
                setLoading(false)
            }


        }).password(values)
    };

    return (
        <>
            <div className='py-2 px-4 flex items-center gap-2  justify-start w-40' onClick={showModal}>
                <MdOutlinePassword
                    size={20}/>
                تغییر کلمه عبور
            </div>
            <Modal
                open={open}
                title="تغییر کلمه عبور "
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form}
                    name="basic"
                    layout='vertical'
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        name="oldPassword"
                        label="کلمه عبور قبلی"
                        rules={[
                            {
                                required: true,
                                message: 'لطفا کلمه عبور قبلی را وارد کنید!',
                            },
                        ]}
                        hasFeedback
                    >
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item
                        name="newPassword"
                        label="کلمه عبور"
                        rules={[
                            {
                                required: true,
                                message: 'لطفا کلمه عبور را وارد کنید!',
                            },
                        ]}
                        hasFeedback
                    >
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        label="تکرار کلمه عبور"
                        dependencies={['newPassword']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'لطفا کلمه عبور را وارد کنید!',
                            },
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('تکرار کلمه عبور درست نمی باشد!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password/>
                    </Form.Item>
                    <Form.Item

                    >
                        <div className="flex justify-end gap-2">
                            <Button key="back" className='defBtn shadow-md bg-gray-100 ' onClick={handleCancel}>
                                انصراف
                            </Button>
                            <Button className='defBtn blueBtn' type="primary" htmlType="submit" loading={loading}>
                                ثبت
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
                <div className='gap-2 flex justify-end items-center'>


                </div>
            </Modal>
        </>
    );
};
export default ChangePass;